/**
 * Simple conditional class name merger
 * Using a simple implementation instead of clsx/tailwind-merge for now
 * to match existing behavior.
 */
export function cn(...inputs: (string | undefined | null | boolean)[]) {
    return inputs.filter(Boolean).join(' ')
}
